// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"81":"70772330","577":"3db41e78","832":"96994483"}[chunkId] + ".chunk.css";
};